<template>
  <div class="historic-table">
    <div class="list-items">
      <div 
        class="column" 
        v-for="(dia, index) in diasApontamentos" 
        v-bind:key="index"
      >
        <div class="header-item">
          <span class="week-day">{{ dia.diaSemana }}</span>
          <span class="date">{{ dia.dataPtBr }}</span>
        </div>
        <div class="sub-header">
          {{ getDuracaoTotal(dia.apontamentos) }}
        </div>
        <div class="body-item">
          <card-apontamento
            v-for="(apontamento, index) in dia.apontamentos"
            v-bind:key="index"
            :apontamento="apontamento"
          ></card-apontamento>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.historic-table {
  display: flex;
  width: 100%;
  height: 100%;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 15px;
  padding: 10px;

  .list-items {
    display: flex;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    border: 1px solid #ccc;

    > .column {
      flex: 1;
      
      .header-item {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: #eaeaea;
        padding: 5px;
        border-right: 1px solid #ccc;

        >:first-child {
          font-weight: bold;
        }
      }

      .sub-header  {
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f7f7f7;
        font-weight: bold;
        border-right: 1px solid #ccc;
      }

      .body-item {
        padding: 5px;
        border-right: 1px solid #ccc;
        background-color: #fbfbfb;
        height: calc(100% - 83px);
      }
    }

    .column:first-child {
      .header-item { border-radius: 10px 0 0 0; }
      .body-item { border-radius: 10px 0 0 0; }
    }
    .column:last-child {
      .header-item { border-radius: 0 10px 0 0; border-right: 0; }
      .sub-header { border-right: 0; }
      .body-item { border-radius: 0 10px 0 0; border-right: 0; }
    }
  }

}
</style>

<script>
import moment from 'moment';

import Uteis from '@/mixins/utils.js';
import CardApontamento from './CardApontamento';

export default {
  name: 'TabelaHistorico',

  mixins: [Uteis],

  components: {
    CardApontamento,
  },

  props: {
    apontamentos: {
      type: Array,
      default: [],
    },
    carregando: {
      type: Boolean,
      default: false,
    },
    datas: {
      type: Object,
      default: {},
    }
  },

  watch: {
    datas() {
      this.atualizarDiasApontamentos();
    },
    apontamentos() {
      this.atualizarDiasApontamentos();
    }
  },

  data() {
    return {
      diasApontamentos: [],
    }
  },

  methods: {
    atualizarDiasApontamentos() {
      const dias = [];
      
      for (let i = 0; i < 7; i++) {
        const data = moment(this.datas.inicio).add(i, 'days');

        dias.push({
          data: data.format('YYYY-MM-DD'),
          dataPtBr: data.format('DD/MM/YYYY'),
          diaSemana: data.lang('pt-BR').format('dddd'),
          apontamentos: this.getApontamentosPorData(data.format('YYYY-MM-DD')),
        });
      }

      this.diasApontamentos = dias;
      this.$forceUpdate();
    },

    getApontamentosPorData(data) {
      const apontamentos = [];

      this.apontamentos.forEach(tarefa => {
        tarefa.horas.forEach(hora => {
          if (hora.data === data) {
            apontamentos.push({
              ...hora,
              ...tarefa
            });
          }
        })
      });

      return apontamentos;
    },

    getDuracaoTotal(apontamentos) {
      let total = 0;
      apontamentos.forEach(item => total += item.qtde);

      return this.getDuracao(total);
    }
  }
}
</script>